import Token from '@web/common/token'
import Locale from '@web/common/locale'
import NetworkError from '@web/common/errors/NetworkError'
import qs from 'qs'
import { withQueryParams } from '@web/common/url'

// Контентный API клуба — относительный путь того же origin (напр. '/club/api/v1')
const CONTENT_BASE = process.env.VUE_APP_AXIOS_BASE_URL_COMMUNITY_API || ''

export async function clubFetch<T> (
  path: string,
  { method = 'GET', params = {}, body }: { method?: string; params?: Record<string, unknown>; body?: unknown } = {}
): Promise<T> {
  // arrayFormat: 'repeat' — ключи-массивы (external_id[], categories.id[], tags.id[])
  // сериализуются как повторяющийся ключ (external_id[]=a&external_id[]=b), как в исходнике
  // (ofetch). Без него qs добавляет индекс → external_id[][0]=... (бэкенд Hydra не понимает).
  // Склейка — через withQueryParams: path может уже нести query. Значения кодируются,
  // иначе '&' в поисковом запросе ломал query.
  const url = withQueryParams(`${CONTENT_BASE}${path}`, qs.stringify(params, { arrayFormat: 'repeat' }))
  const response = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${Token.get()}`,
      'Accept-Language': Locale.get(),
      ...(body ? { 'Content-Type': 'application/json' } : {})
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  })
  if (!response.ok) {
    // Контентный контур клуба идёт мимо @web/api/client, поэтому разлогин на 401
    // делаем здесь тем же способом, что и client.processResponse.
    if (response.status === 401) {
      document.dispatchEvent(new Event('logout'))
    }
    // NetworkError несёт response/status — на них смотрит useErrorHandler.setErrors
    // (404 → редирект на страницу 404). Обычный Error статус терял.
    throw new NetworkError(response)
  }
  return response.json() as Promise<T>
}
